import { render, staticRenderFns } from "./SSRAgTable.vue?vue&type=template&id=cd563a6e"
import script from "./SSRAgTable.vue?vue&type=script&lang=js"
export * from "./SSRAgTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports